import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[validateMaxChar][formControlName],[validateMaxChar][formControl],[validateMaxChar][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MaxCharactersValidatorDirective),
            multi: true,
        },
    ],
})
export class MaxCharactersValidatorDirective implements Validator
{
    @Input() validateMaxChar = 0;

    public validate(control: AbstractControl): { [key: string]: any } {
        if (control.value === null || control.value === '') {
            return null;
        }

        const max = Number(this.validateMaxChar);
        const size = typeof control.value === 'number' ? control.value : String(control.value).length;
        return size > max ? { max: { max } } : null;
    }
}
